import {CalendarMonth} from "../components/CalendarMonth.jsx";
import React from "react";
import {toDateInputValue} from "../utilities/db_time_date_utilities";

export const LAYOUT_SELECT = {
    1: <CalendarMonth/>,
}

export const SHORT_MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const NEW_TASK = {
    title: "",
    priority: 0,
    date: {date: toDateInputValue(new Date()), time: "00:00"},
    description: "",
    repeat: false,
    location: {_long: 0, _lat: 0}
}

export const DAY_NAMES_SHORT = ['M', 'D', 'W', 'D', 'V', 'Z', 'Z'];
export const DAYNAME_NUMBERS = {
    maandag: 1, dinsdag: 2, woensdag: 3, donderdag: 4, vrijdag: 5, zaterdag: 6, zondag: 7
};


export const dayNumberNames = {
    1: "Maandag", 2: 'Dinsdag', 3: 'Woensdag', 4: 'Donderdag', 5: 'Vrijdag', 6: 'Zaterdag', 7: 'Zondag'
};
export const PRIORITY_COLOR = {
    0: 'white', 1: 'orange', 2: 'red'
}
export const MONTH_NUMBER = {
    0: "Januari",
    1: "Februari",
    2: "Maart",
    3: "April",
    4: "Mei",
    5: "Juni",
    6: "Juli",
    7: "Augustus",
    8: "September",
    9: "Oktober",
    10: "November",
    11: "December",

}
export const MONTHS_IN_YEAR = [
    {number: 0, month: "Januari"},
    {number: 1, month: "Februari"},
    {number: 2, month: "Maart"},
    {number: 3, month: "April"},
    {number: 4, month: "Mei"},
    {number: 5, month: "Juni"},
    {number: 6, month: "Juli"},
    {number: 7, month: "Augustus"},
    {number: 8, month: "September"},
    {number: 9, month: "Oktober"},
    {number: 10, month: "November"},
    {number: 11, month: "December"},

]

